import { formatCurrency } from '../../lib/formatters';

/** Pure view-model for the Syndications dashboard tiles (10/23). `summary` = GET /syndications-outstanding/summary. */
export function tilesFromSummary(s) {
  if (!s) return [];
  const ns = s.needs_syndication || {};
  const aw = s.offers_awaiting_reply || {};
  const adj = s.adjustments_pending || {};
  const rdy = s.ready_to_confirm || {};
  const w = s.wires_due || {};
  const wd = s.withdrawals_pending || {};
  return [
    { key: 'needs', value: ns.count || 0, label: 'Deals needing syndication', to: '/syndications/unsyndicated',
      sub: `${ns.ready || 0} ready · ${ns.no_commission || 0} without commission · ${formatCurrency(ns.funding_total || 0)} funded`, warn: (ns.count || 0) > 0 },
    { key: 'awaiting', value: aw.invitations || 0, label: 'Offer emails awaiting a reply', to: '#offers-in-flight',
      sub: `${aw.deals || 0} deal${aw.deals === 1 ? '' : 's'}${aw.never_emailed ? ` · ${aw.never_emailed} never emailed` : ''}`, warn: (aw.never_emailed || 0) > 0 },
    { key: 'adjust', value: adj.count || 0, label: 'Adjustment requests to approve', to: '#offers-in-flight',
      sub: `${adj.deals || 0} deal${adj.deals === 1 ? '' : 's'}`, warn: (adj.count || 0) > 0 },
    { key: 'ready', value: rdy.deals || 0, label: 'Offers ready to confirm', to: '#offers-in-flight',
      sub: 'every invitee has answered', warn: false, good: (rdy.deals || 0) > 0 },
    { key: 'wires', value: w.count || 0, label: 'Wires due from syndicators', to: '/syndications/payables',
      sub: `${formatCurrency(w.total_outstanding || 0)} outstanding`, warn: (w.count || 0) > 0 },
    { key: 'withdrawals', value: wd.count || 0, label: 'Withdrawals to approve', to: '/syndication-withdrawals',
      sub: 'pending syndicator requests', warn: (wd.count || 0) > 0 },
  ];
}

